<!-- 搜索项 -->
<template>
  <div>
    <el-row :gutter="8">
      <el-col :span="2"></el-col>
      <el-col :span="7">搜索项</el-col>
      <el-col :span="5">符号</el-col>
      <el-col :span="10">值</el-col>
    </el-row>
    <div class="mt10">
      <template v-for="(item, index) in searchDataList">
        <el-row :gutter="8" class="mt10">
          <!-- 操作删除 -->
          <el-col :span="2"></el-col>
          <!-- 搜索项 -->
          <el-col :span="7"
            ><el-select
              v-model="item.key"
              @change="(value) => handleChange(item, value)"
            >
              <el-option
                v-for="colItem in columns"
                :key="colItem.prop"
                :label="colItem.label"
                :value="colItem.prop"
              /> </el-select
          ></el-col>
          <!-- 符号 -->
          <el-col :span="5">
            <el-select v-model="item.symbol">
              <el-option
                v-for="(key, value) of getSymbol(item.key)"
                :key="key"
                :label="key"
                :value="value"
              /> </el-select
          ></el-col>
          <!-- 搜索值 -->
          <el-col :span="10">
            <!-- 字典 -->
            <template v-if="getColumn(item.key)?.type === 'dict'">
              <el-select
                v-model="item.value"
                filterable
                clearable
                :placeholder="
                  item.placeholder
                    ? item.placeholder
                    : `请选择${getColumn(item.key)?.label}`
                "
              >
                <el-option
                  v-for="subItem in getDictListByParentCode(
                    getColumn(item.key)?.dictKey
                  )"
                  :key="subItem.libraryCode"
                  :label="subItem.libraryName"
                  :value="subItem.libraryCode"
                />
              </el-select>
            </template>
            <!-- 时间 -->
            <template v-else-if="getColumn(item.key)?.type === 'date'">
              <el-date-picker
                v-model="queryParams[item.prop]"
                style="width: 200px"
                :disabled="['isNull', 'isNotNull'].includes(item.symbol)"
                value-format="YYYY-MM-DD"
                type="daterange"
                range-separator="-"
                unlink-panels
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </template>
            <template v-else>
              <el-input v-model="item.value" placeholder="请输入" />
            </template>
          </el-col>
        </el-row>
      </template>
    </div>
    <el-button iconClass="Plus" text plain type="primary" @click="handleAdd"
      >新增</el-button
    >
  </div>
</template>

<script setup>
import { ref, reactive } from "vue";
import useCacheStore from "@/store/modules/cache";
import { isNull } from "@/utils/fangerUtils";
const cacheStore = useCacheStore(); // 缓存store
const { getDictListByParentCode, warehouse } = cacheStore;

const props = defineProps({
  columns: {
    // 类配置
    type: Array,
    default: () => [],
  },
  advancedSearchAttrName: {
    // 高级搜索可以搜索的属性
    type: Array,
    default: () => [],
  },
});

const queryParams = ref({});
const queryRef = ref(null);

const searchDataList = reactive([]);
const selectValue = ref("");
searchDataList.push(
  reactive({
    key: "",
    symbol: "",
    value: "",
  })
);

const handleAdd = () => {
  searchDataList.push(
    reactive({
      key: "",
      symbol: "",
      value: "",
    })
  );
};

const numberJudgeSymbol = {
  eq: "=",
  ne: "!=",
  gt: ">",
  ge: ">=",
  lt: "<",
  le: "<=",
  between: "介于",
  notBetween: "不介于",
  isNull: "为空",
  isNotNull: "不为空",
};

const dateJudgeSymbol = {
  between: "介于",
  notBetween: "不介于",
  isNull: "为空",
  isNotNull: "不为空",
};
const stringJudgeSymbol = {
  eq: "=",
  like: "包含",
  notLike: "不包含",
  likeRight: "以...开头",
  likeLeft: "以...结尾",
  isNull: "为空",
  isNotNull: "不为空",
};

const getColumn = (prop) => {
  return props.columns.find((item) => item.prop === prop);
};

const getSymbol = (prop) => {
  const col = getColumn(prop);
  if (["dict"].includes(col?.type)) {
    return { eq: "=" };
  }
  if (["date"].includes(col?.type)) {
    return dateJudgeSymbol;
  } else {
    return stringJudgeSymbol;
  }
};

const handleChange = (item, value) => {
  const col = getColumn(value);
  item.value = "";
  if (["dict"].includes(col?.type)) {
    item.symbol = "eq";
  }
  if (["date"].includes(col?.type)) {
    item.symbol = "between";
  } else {
    item.symbol = "eq";
  }
};
</script>

<style lang="scss" scoped></style>
